export default __webpack_public_path__ + "static/media/first-american-logo.6c35659e.png";